import { Box } from "@mui/material";
import * as React from "react";
import DialogCustom from "../../common/components/DialogCustom";
import { some } from "../../common/constants";
import SchemaForm from "../../common/SchemaForm";

interface Props {
  onSubmit: (formVal: some, setLoading: (loading: boolean) => void) => void;
  open: boolean;
  onClose: () => void;
  formData?: some;
}

const SchemaFormContent: React.FunctionComponent<Props> = (props) => {
  const { onSubmit, formData, onClose } = props;
  return (
    <>
      <SchemaForm
        onSubmit={onSubmit}
        initialData={formData}
        onCancel={onClose}
        schema={{
          changeDataBeforeSubmit(values) {
            return { ...values, organizationId: formData?.groupData?.id };
          },
          fields: ({ formProps: { intl } }) => {
            return {
              code: {
                type: "text-field",
                label: intl.formatMessage({ id: "company.partitionId" }),
                placeholder: intl.formatMessage({ id: "enter" }),
                register: { required: true },
                propsWrapper: { xs: formData?.id ? 6 : 4 },
                readOnly: !!formData?.id,
                hidden: !formData?.id,
              },
              name: {
                type: "text-field",
                label: intl.formatMessage({ id: "company.partitionName" }),
                placeholder: intl.formatMessage({ id: "enter" }),
                register: { required: true },
                propsWrapper: { xs: formData?.id ? 6 : 4 },
              },
              description: {
                type: "text-field",
                label: intl.formatMessage({ id: "company.partitionDesc" }),
                placeholder: intl.formatMessage({ id: "enter" }),
                multiline: true,
                rows: 4,
              },
            };
          },
        }}
        formProps={{
          autoComplete: "nope",
          autoCorrect: "off",
        }}
      />
    </>
  );
};

const CompanyDialog: React.FunctionComponent<Props> = (props) => {
  const { open, onClose, formData } = props;

  return (
    <DialogCustom
      open={!!open}
      keepMounted={false}
      onClose={onClose}
      PaperProps={{
        style: { minWidth: 780 },
      }}
      maxWidth="xl"
      title={formData?.id ? "company.update" : "company.add"}
    >
      <Box padding={2}>
        <SchemaFormContent {...props} />
      </Box>
    </DialogCustom>
  );
};
export default CompanyDialog;
